import { renderComponent, type ColumnDef } from '@tanstack/svelte-table';
import type { PageData } from '../../routes/(private)/$types';
import Overview from '../../routes/uilib/domains/column/Overview.svelte';
import Link from '../../routes/uilib/domains/column/Link.svelte';
import Url from '../../routes/uilib/domains/column/Url.svelte';
import Brand from '../../routes/uilib/domains/column/Brand.svelte';
import Status from '../../routes/uilib/domains/column/Status.svelte';
import { formatDateTime } from '$lib/utils/formatDateTime';
import { createTableColumns } from '@cf/ui-lib/utils';

const defaultColumns: ColumnDef<PageData>[] = [
	// action
	{
		accessorKey: 'id',
		cell: (info) => renderComponent(Overview, { id: info.getValue() as string }),
		enableHiding: false
	},
	{
		accessorKey: 'domain_name',
		cell: (info) => renderComponent(Url, { label: info.getValue() as string, href: `//${ info.getValue() }` }),
		header: () => 'URL'
	},
	{
		accessorKey: 'product_link',
		cell: (info) => renderComponent(Link, { href: info.getValue() as string }),
		header: () => 'Link'
	},
	{
		accessorKey: 'country',
		header: () => 'Country'
	},
	{
		accessorKey: 'status',
		cell: (info) => renderComponent(Status, { status: info.getValue() as string, id: info.row.id }),
		header: () => 'Status'
	},
	{
		accessorKey: 'brand.logo',
		cell: (info) => renderComponent(Brand, { brand_url: info.getValue() as string }),
		header: () => 'Brand'
	},
	{
		accessorKey: 'created_at',
		cell: (info) => {
			return formatDateTime(new Date(info.getValue() as string));
		},
		header: () => 'Reported On'
	}
];

export const domainsColumns: ColumnDef<PageData>[] = defaultColumns.map((item) => ({
	cell: (info) => info.getValue(),
	footer: (info) => info.column.id,
	...item
}));

interface DomainColumnsCallback {
	onDomainRemove: (id: string) => void;
	onStatusChagne: (id: string, status: string) => void;
}

export const createDomainColumns = (callbacks: DomainColumnsCallback) => {
	return createTableColumns<any>([
		['id', '', (info) => renderComponent(Overview, {
			id: info.getValue() as string,
			onDomainRemove: callbacks.onDomainRemove,
		}), undefined],
		['domain_name', 'URL', (info) => renderComponent(Url, { label: info.getValue() as string, href: `//${ info.getValue() }` }), undefined],
		['domain_name', 'Link', (info) => renderComponent(Link, { href: `//${info.getValue()}` }), undefined],
		['country', 'Country', (info) => info.getValue(), undefined],
		['status', 'Status', (info) => renderComponent(Status, { status: info.getValue() as string, id: info.row.original.id, value: info.getValue() as string , onStatusChagne: callbacks.onStatusChagne}), undefined],
		['brand.logo_path', 'Brand', (info) => renderComponent(Brand, { brand_url: info.getValue() as string }), undefined],
		['created_at', 'Reported On', (info) => formatDateTime(new Date(info.getValue() as string)), undefined]
	]);
};
